module.exports = __webpack_public_path__ + "img/ufo.f911ffa5.svg";